

































import Vue from "vue";

export default Vue.extend({
    name: "Clamp",
    components: {},
    props: {
        id: { type: String, default: null, required: true },
        showReadMore: { type: Boolean, default: true },
        expanded: { type: Boolean, default: false }
    },
    data: () => ({ isOverflown: false, windowWidth: 0 }),
    mounted() {
        this.$nextTick(function () {
            window.addEventListener("resize", this.onResize);
            this.setPlainContent();

            //Workaround to wait for clamp to be properly rendered. scrollWidth is 0 otherwise
            const interval = setInterval(() => {
                if (this.clamp?.scrollWidth) {
                    this.onResize();
                    clearInterval(interval);
                }
            }, 1);

            if (!this.isOverflown) {
                this.$emit("read");
            }
        });
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
    computed: {
        clamp(): HTMLElement {
            return document.getElementById("clamp_" + this.id);
        },
        clampPlainContent(): HTMLElement {
            return document.getElementById("clampPlainContent_" + this.id);
        }
    },
    methods: {
        onResize() {
            if (this.windowWidth != document.documentElement.clientWidth) {
                this.collabs();
                this.windowWidth = document.documentElement.clientWidth;
            }

            if (this.clamp) {
                this.isOverflown = this.clamp.scrollWidth > this.clamp.clientWidth || this.clamp.scrollHeight > this.clamp.clientHeight;
            } else {
                this.isOverflown = false;
            }
        },
        setPlainContent() {
            if (this.clamp) {
                // Remove line breaking elements
                const text = (this.clamp.firstChild as HTMLElement).innerHTML.replace(
                    /<\s*div[^>]*\/?>|<\/div*>|<br\s*\/?>|<\s*ul[^>]*\/?>|<\/ul*>|<\s*ol[^>]*\/?>|<\/ol*>|<\s*li[^>]*\/?>|<\/li*>|<\s*p[^>]*\/?>|<\/p*>/gi,
                    " "
                );
                this.clampPlainContent.innerHTML = text;
            }
        },
        expand() {
            this.$emit("update:expanded", true);
        },
        collabs() {
            this.$emit("update:expanded", false);
        }
    }
});
